<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="handleSave"
        class="rkm-modal"
        large
        ref="RkmModal"
        title="Alergias / Reações adversas"
    >
        <Form
            :data="data"
            :index="index"
            @save="close()"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        index: 0
    }),
    methods: {
        async open(row) {

            this.$refs.RkmModal.show()

            if (row) {

                this.index = row.index

                await this.$nextTick()

                this.$refs.Form.setModel({
                    tipoId: row.item.alergia.tipo.id,
                    criticidadeId: row.item.alergia.criticidade.id,
                    alergia: {
                        id: row.item.alergia.id,
                        agenteSubstanciaEspecifica: row.item.alergia.agenteSubstanciaEspecifica
                    },
                    reacoesObservacoes: row.item.alergia.reacoesObservacoes,
                    cid: row.item.alergia.cid,
                })
            } else {

                this.index = this.data.model.alergias.length
            }
        },
        handleSave() {
            this.$refs.Form.save()
        },
        close() {
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>